import React, { useState, useEffect } from 'react';
import { number, func, bool } from 'prop-types';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage, useForm } from '@laramie/ui';
import { APIS } from '../../../config/apis';
import { ServerRequest } from '../../../utils/apiweb';
import { CheckboxButton, CheckboxButtonGroup, FormError, FormLabel, InputLista, InputNumber, Modal } from '../../common';
import {TIPS} from "../../../consts/tips";

import { useFormErrors } from '../../hooks/useFormErrors';
import { isNull, isValidNumber } from '../../../utils/validator';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';

const ClaseElementoModal = (props) => {

    //variables
    const entityInit = {
        id: 0,
        tipoTributo: 0,
        codigo: '',
        orden: '',
        nombre: '',
        ejecucionPeriodica: false
    };

    //hooks
    const [state, setState] = useState({
        loading: false,
        entity: entityInit,
        showInfo: false
    });

    const mount = () => {

        if (props.id > 0) {
            FindClaseElemento();
        }
   
        const unmount = () => {}
        return unmount;
    }
    useEffect(mount, []);

    const [ formValues, formHandle, , formSet ] = useForm({
        codigo: '',
        orden: '',
        nombre: '',
        ejecucionPeriodica: false
    });

    const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors);

    //handles
    const handleClickAceptar = () => {
        if (validate()) {
            if (props.id == 0) {
                AddClaseElemento();
            }
            else {
                ModifyClaseElemento();
            }
        };
    };
    const handleClickCancelar = () => {
        props.onDismiss();
    }
    
    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
            const message = error.message;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
            return {...prevState, loading: false};
            });
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }  

    // funciones
    function getErrors() {

        const errors = {};

        if (formValues.codigo.length === 0) errors.codigo = VALIDATION_MESSAGE.REQUIRED
        if (isEmptyValue(formValues.orden)) errors.orden = VALIDATION_MESSAGE.REQUIRED
        if (formValues.nombre.length === 0) errors.nombre = VALIDATION_MESSAGE.REQUIRED

        return errors;
    }

    function getFormatErrors() {

        const errors = {};
        if (props.disabled) return errors;

        if (!isEmptyValue(formValues.orden) && !isValidNumber(formValues.orden, true)) errors.orden = 'Ingresá un número mayor a cero';

        return errors;
    }

    function isEmptyValue(valor) {
        return isNull(valor) || valor.toString().length === 0;
    }   
    
    function FindClaseElemento() {
    
        setState(prevState => {
          return {...prevState, loading: true};
        });
    
        const callbackSuccess = (response) => {
            response.json()
            .then((data) => {    
                setState(prevState => {
                  return {...prevState, loading: false, entity: data};
                });

                formSet({
                    idTipoTributo: data.idTipoTributo,
                    codigo: data.codigo,
                    orden: data.orden,
                    nombre: data.nombre,
                    ejecucionPeriodica: data.ejecucionPeriodica
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                  return {...prevState, loading: false};
                });
            });
        };
    
        const paramsUrl = `/${props.id}`;
    
        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.CLASE_ELEMENTO,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );
    
    }
    
    function AddClaseElemento() {
        const method = REQUEST_METHOD.POST;
        const paramsUrl = null;
        SaveClaseElemento(method, paramsUrl);
    }
    
    function ModifyClaseElemento() {
        const method = REQUEST_METHOD.PUT;
        const paramsUrl = `/${props.id}`;
        SaveClaseElemento(method, paramsUrl);
    }    

    function SaveClaseElemento(method, paramsUrl) {

        setState(prevState => {
          return {...prevState, loading: true};
        });
    
        const callbackSuccess = (response) => {
          response.json()
          .then((row) => {
            setState(prevState => {
                return {...prevState, loading: false};
            });
            props.onConfirm(row.id);
          })
          .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
              return {...prevState, loading: false};
            });
          });
        };
    
        const dataBody = {
                id: props.id,
                idTipoTributo: props.idTipoTributo,
                codigo: formValues.codigo,
                orden: parseInt(formValues.orden),
                nombre: formValues.nombre,
                ejecucionPeriodica: formValues.ejecucionPeriodica
        };
    
        ServerRequest(
            method,
            null,
            true,
            APIS.URLS.CLASE_ELEMENTO,
            paramsUrl,
            dataBody,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );
    
    }

  return (
    <Modal
      size="lg"
      title={`Clase elemento: ${(props && props.id > 0) ? state.entity.nombre : "Nuevo"}`}
      tipName={TIPS.NAME.MODALS.CLASE_ELEMENTO_MODAL}
      onEscape={() => handleClickCancelar()}
      body={(
            <div className="row form-basic">
                <div className="mb-3 col-12 col-md-4">
                    <label htmlFor="idTipoTributo" className="form-label">Tipo de tributo</label>
                    <InputLista
                        name="idTipoTributo"
                        placeholder=""
                        className="form-control"
                        value={ props.idTipoTributo }
                        title="Tipo tributo"
                        lista="TipoTributo"
                        disabled={true}
                    />
                    <FormError />
                </div>
                <div className="mb-3 col-12 col-md-4">
                    <FormLabel htmlFor="codigo" required>Código</FormLabel>
                    <input
                        name="codigo"
                        placeholder=""
                        className={`form-control ${errorOf('codigo') ? 'is-invalid' : ''}`}
                        value={ formValues.codigo }
                        onChange={ formHandle }
                        disabled={props.disabled}
                    />
                    <FormError message={errorOf('codigo')} />
                </div>
                <div className="mb-3 col-12 col-md-4">
                    <FormLabel htmlFor="orden" required>Orden</FormLabel>
                    <input
                        name="orden"
                        type="number"
                        placeholder=""
                        className={`form-control ${errorOf('orden') ? 'is-invalid' : ''}`}
                        value={ formValues.orden }
                        onChange={ formHandle }
                        disabled={ props.disabled }
                    />
                    <FormError message={errorOf('orden')} />
                </div>
                <div className="mb-3 col-12 col-md-8">
                    <FormLabel htmlFor="nombre" required>Nombre</FormLabel>
                    <input
                        name="nombre"
                        type="text"
                        placeholder=""
                        className={`form-control ${errorOf('nombre') ? 'is-invalid' : ''}`}
                        value={ formValues.nombre }
                        onChange={ formHandle }
                        disabled={props.disabled}
                    />
                    <FormError message={errorOf('nombre')} />
                </div>
                <div className="mb-3 col-12 col-md-4">
                    <CheckboxButtonGroup label="Opciones">
                        <CheckboxButton
                            name="ejecucionPeriodica"
                            label="Ejecución periódica"
                            checked={formValues.ejecucionPeriodica}
                            onChange={formHandle}
                            disabled={props.disabled}
                        />
                    </CheckboxButtonGroup>
                </div>
            </div>
      )}
      footer={!props.disabled ? (<>
            <button className="btn btn-outline-primary" data-dismiss="modal" onClick={ (event) => handleClickCancelar() }>Cancelar</button>
            <button className="btn btn-primary" data-dismiss="modal" onClick={ (event) => handleClickAceptar() }>Aceptar</button>
      </>) : (
            <button className="btn back-button" data-dismiss="modal" onClick={ (event) => handleClickCancelar() }>Volver</button>
      )}
      footerClassName={props.disabled ? 'f-align' : ''}
    />
  );
}

ClaseElementoModal.propTypes = {
    disabled: bool,
    id: number.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

ClaseElementoModal.defaultProps = {
    disabled: false
};

export default ClaseElementoModal;